import { Entity, LiveData } from '@toeverything/infra';

import type { QuickSearchSession } from '../providers/quick-search-provider';
import type { DocDisplayMetaService } from '../services/doc-display-meta';
import type { RecentDocsService } from '../services/recent-pages';
import type { QuickSearchGroup } from '../types/group';
import type { QuickSearchItem } from '../types/item';

const group = {
  id: 'recent-docs',
  label: {
    key: 'com.pique.cmdk.affine.category.affine.recent',
  },
  score: 15,
} as QuickSearchGroup;

export class RecentDocsQuickSearchSession
  extends Entity
  implements QuickSearchSession<'recent-doc', { docId: string }>
{
  constructor(
    private readonly recentDocsService: RecentDocsService,
    private readonly docDisplayMetaService: DocDisplayMetaService
  ) {
    super();
  }

  query$ = new LiveData('');

  items$: LiveData<QuickSearchItem<'recent-doc', { docId: string }>[]> =
    LiveData.computed(get => {
      const query = get(this.query$);

      if (query) {
        return []; /* recent docs only for empty query */
      }

      const docRecords = this.recentDocsService.getRecentDocs();

      return docRecords
        .filter(doc => !get(doc.trash$))
        .filter(doc => {
          const tags = get(doc.meta$).tags || [];
          return !tags.includes('temp:peek');
        })
        .map<QuickSearchItem<'recent-doc', { docId: string }>>(docRecord => {
          const { title, icon } =
            this.docDisplayMetaService.getDocDisplayMeta(docRecord);

          return {
            id: 'recent-doc:' + docRecord.id,
            source: 'recent-doc',
            group: group,
            label: {
              title: title,
            },
            score: 0,
            icon,
            timestamp: docRecord.meta$.value.updatedDate,
            payload: { docId: docRecord.id },
          };
        });
    });

  query(query: string) {
    this.query$.next(query);
  }
}
